import { render } from "./ListLayout.vue?vue&type=template&id=23c720f6&scoped=true"
import script from "./ListLayout.vue?vue&type=script&lang=js"
export * from "./ListLayout.vue?vue&type=script&lang=js"

import "./ListLayout.vue?vue&type=style&index=0&id=23c720f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c720f6"]])

export default __exports__